import * as React from 'react';
import './FeedHeader.css';
import ArrowLeft from '@material-ui/icons/ArrowBack';

interface Props {
	backgroundUrl?: string;
	header: string;
	onBack?: () => void;
}

const FeedHeader: React.FC<Props>  = props => {
	return <div className="feed-header">
		{props.backgroundUrl && <div className="feed-header-background" style={{ backgroundImage: `url(${props.backgroundUrl})` }} />}

		<div className="feed-header-content">
			<div className="feed-header-content__wrapper">
				<div className="feed-header__back" onClick={props.onBack}>
					<ArrowLeft />
					
					Назад
				</div>

				<div className="feed-header-content__header">
					{props.header}
				</div>
			</div>
		</div>
	</div>;
};

export default FeedHeader;
